/**
 * @generated SignedSource<<0e8353be372074dc92cec493eb9828eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespPersonalizedAuctionsModuleLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespPersonalizedAuctionsModule_user">;
  readonly " $fragmentType": "SbRespPersonalizedAuctionsModuleLazy_user";
};
export type SbRespPersonalizedAuctionsModuleLazy_user$key = {
  readonly " $data"?: SbRespPersonalizedAuctionsModuleLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespPersonalizedAuctionsModuleLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespPersonalizedAuctionsModuleLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespPersonalizedAuctionsModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "63bcd630855752b6fa0b8895833d0fd6";

export default node;
